import { Component, NgZone, OnInit, ViewChild } from '@angular/core';

import { AlertController, IonRouterOutlet, isPlatform, MenuController, ModalController, NavController, Platform, ToastController } from '@ionic/angular';

import { OfflineStorageService } from './services/offline-storage.service';
import { INTRO_KEY } from 'src/app/guards/intro.guard';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from './store/app.state';
import { getLoading } from './store/selectors/shared.selector';
import * as fromAuthActions from './store/actions/auth.actions'
import { App, AppInfo, URLOpenListenerEvent } from '@capacitor/app';
import { getCurrentRoute } from './store/selectors/router.selector';
import { AutoCloseOverlaysService } from './services/autocloseoverlays.service';
import { getUserSession } from 'src/app/store/selectors/auth.selectors';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';
import { Deeplinks } from '@awesome-cordova-plugins/deeplinks/ngx';
import { Router } from "@angular/router";
import { reloadOrderHistory } from './store/actions/order.action';
import { FCM } from "@capacitor-community/fcm";
import { ActionPerformed, PushNotifications } from "@capacitor/push-notifications";
import { setFCMToken } from './store/actions/shared.actions';
import { VersionService } from './services/version.service';
import { Market } from '@awesome-cordova-plugins/market/ngx';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {

  appPages = [
    {
      title: 'Dashboard',
      url: '/home/bottom-tabs/dashboard',
      icon: 'home'
    },
  ];

  loggedIn: any;

  dark = false;
  swipeGesture = false;
  disabledMenu = true;

  showLoading$: Observable<boolean>;
  currentRoute$: Observable<any>;
  currentPage = '';
  userSession$: Observable<any>;
  userSession = null;

  homeTab = 0;
  profileTab = -1;
  notificationTab = -1;
  rideTab = -1;
  otherTab = -1;

  homePages = ["dashboard"];
  profilePages = ["profile"];
  notificationPages = ["notifications"];
  ridePages = ["ride", "premium-ride"];
  otherPages = ["calendar", "points", "token", "pass"];

  fcmToken = '';

  appInfo: AppInfo;

  @ViewChild(IonRouterOutlet, { static : true }) ionRouterOutlet: IonRouterOutlet;

  constructor(
    private menu: MenuController,
    private offlineStorageService: OfflineStorageService,
    private store: Store<AppState>,
    private platform: Platform,
    private navCtrl: NavController,
    private ngZone: NgZone,
    private autoCloseOverlaysService: AutoCloseOverlaysService,
    private alertController: AlertController,
    private androidPermissions: AndroidPermissions,
    private deeplinks: Deeplinks,
    private router: Router,
    private zone: NgZone,
    private modalController: ModalController,
    private versionService: VersionService,
    private market: Market
  ) {
    this.initializeApp();
  }

  async ngOnInit() {
    console.log('AppComponent ngOnInit');
  }

  initializeApp() {

    this.platform.ready().then(async () => {

      this.userSession$ = this.store.select(getUserSession);
      this.showLoading$ = this.store.select(getLoading);
      this.currentRoute$ = this.store.select(getCurrentRoute);

      this.userSession$.pipe().subscribe((userSession: any) => {
        console.log({userSession});
        this.userSession = userSession;
        // this.setUpDeepLink();
      });

      this.store.dispatch(fromAuthActions.autoLogin());

      // Back navigation
      this.currentRoute$.subscribe((route) => {
        if (route && route.url ) {
          this.currentPage = route.url.substring(route.url.lastIndexOf('/') + 1);
          this.homeTab = this.homePages.indexOf(this.currentPage);
          this.profileTab = this.profilePages.indexOf(this.currentPage);
          this.rideTab = this.ridePages.indexOf(this.currentPage);
          this.notificationTab = this.notificationPages.indexOf(this.currentPage);
          this.otherTab = this.otherPages.indexOf(this.currentPage);
        }
      });



    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      this.zone.run(() => {
          // Example url: https://beerswift.app/tabs/tab2
          // slug = /tabs/tab2
          const slug = event.url.split("shopeepay/order-status/").pop();
          if (slug) {
              this.navCtrl.navigateForward(`home/bottom-tabs/token/token-order-history/${slug}`);
               this.modalController.dismiss();
              this.store.dispatch(reloadOrderHistory());
              console.log({slug});
          }
          // If no match, do nothing - let regular routing
          // logic take over
      });
    });

      window.addEventListener('navigation:back', async (e: any) => {
        console.log('navigation:back', e?.detail);
        const isNavigateBack = e?.detail;
        if (isNavigateBack) {
          if (this.ionRouterOutlet.canGoBack()) {
            if(this.homeTab >= 0 || this.profileTab >= 0 || this.notificationTab >= 0 || this.rideTab >= 0 || this.otherTab >= 0){
              console.log('confirmExit sa header');
              this.confirmExit();
            }
            else{
              this.ngZone.run(() => {
                console.log('BACK sa this.ionRouterOutlet.canGoBack()', this.ionRouterOutlet.canGoBack());
                this.navCtrl.pop();
              });
            }
          } else {
            if (this.homeTab > 0 || this.profileTab > 0 || this.notificationTab > 0 || this.rideTab > 0) {
              this.ngZone.run(() => {
                console.log('BACK sa this.homeTab > 0 || this.profileTab > 0 || this.moreTab > 0');
                this.navCtrl.back();
              });
            } else {
              console.log('confirmExit sa header');
              this.confirmExit();
            }
          }
        }
      });
      this.platform.backButton.subscribeWithPriority(999, async () => {
        console.log('Handler was called!');
        const hasClosedOverlays = await this.autoCloseOverlaysService.trigger();
        console.log({hasClosedOverlays});
        if (hasClosedOverlays) {
          console.log('do not back navigation, close overlays');
        } else {
            console.log('call navigate back event');
            window.dispatchEvent(new CustomEvent('navigation:back', { detail: true}));
        }
      });

      // Logout
      window.addEventListener('auth:logout', (e: any) => {
        console.log('auth:logout', e?.detail);
        const isLogout = e?.detail;
        if (isLogout) {
          this.logout();
        }
      });

      // Session Timeout
      window.addEventListener('auth:timeout', (e: any) => {
        console.log('auth:timeout', e?.detail);
        const isTimeout = e?.detail;
        if (isTimeout && this.userSession) {
          this.autoCloseOverlaysService.trigger();
          this.logout();
          this.sessionTimeOut();
        }
      });

      if (isPlatform('android')) {
        // Request Permission
        this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.READ_PHONE_STATE).then(
          result => {
            console.log('READ_PHONE_STATE Has permission ?',result.hasPermission);
            this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.READ_PHONE_STATE);
          },
          err => {
            console.log('READ_PHONE_STATE checkPermission error', err);
          }
        );
      }

      if(isPlatform('capacitor')){
        App.getInfo().then((info) => {
          console.log('App info', info);
          this.appInfo = info;
          this.offlineStorageService.setObject('appInfo', this.appInfo);
        });

        const platform = isPlatform('android') ? 'android' : isPlatform('ios') ? 'ios' : 'web';

        const openStorelisting = () => {
          const appId = isPlatform('ios') ? 'id6751761435' : 'tech.viscion.lovebus';
          this.market.open(appId);
          App.exitApp();
        }

        const newVersionAvailable = async (isForceUpdate = false) => {
          let buttons = [
            {
              text: 'NO THANKS',
              id: 'cancel-button',
              handler: () => { }
            },
            {
              text: 'UPDATE',
              id: 'confirm-button',
              handler: async () => {
                openStorelisting();
              }
            }
          ];
          if (isForceUpdate) {
            buttons = [
              {
                text: 'UPDATE',
                id: 'confirm-button',
                handler: async () => {
                  openStorelisting();
                }
              }
            ];
          }
          const alert = await this.alertController.create({
            header: 'Update Love Bus',
            message: 'Love Bus recommends that you update to the latest version.',
            buttons,
            backdropDismiss: false
          });
          await alert.present();
        }

        this.versionService.getLatestVersion(platform).subscribe((res) => {
          if(res){
            const appVersion = res?.details;
            console.log({appVersion}, this.appInfo.version);

            if (appVersion.lovebusVersionLatest === this.appInfo.version) {
              console.log("App is up to date");
              return;
            } else if (appVersion.lovebusVersion === this.appInfo.version) {
              console.log("App is up to date");
              return;
            } else {
              newVersionAvailable(true);
            }
          }
        });

        const registerNotifications = async () => {
          let permStatus = await PushNotifications.checkPermissions();

          if (permStatus.receive === 'prompt') {
            permStatus = await PushNotifications.requestPermissions();
          }

          if (permStatus.receive !== 'granted') {
            console.warn('FCM.checkPermissions denied')
            throw new Error('User denied permissions!');
          } else {
            await PushNotifications.register();
            if (isPlatform('ios')) {
              // Get FCM token instead the APN one returned by Capacitor for IOS
              FCM.getToken()
              .then((result) => {
                console.info('FCM.getToken() registration', result.token);
                this.fcmToken = result.token;
                this.offlineStorageService.setObject('deviceToken', result.token);
                this.store.dispatch(setFCMToken({data: result.token}));
              }).catch((err) => console.warn('FCM.getToken() error', err));
            } else if (isPlatform('android')) {
              // For Android
              await PushNotifications.addListener('registration', token => {
                console.info('Registration token: ', token.value);
                this.fcmToken = token.value;
                this.offlineStorageService.setObject('deviceToken', token.value);
                this.store.dispatch(setFCMToken({data: token.value}));
              });
            }

            await PushNotifications.addListener('pushNotificationReceived', notification => {
              console.log('Push notification received: ', notification);
            });

            await PushNotifications.addListener('pushNotificationActionPerformed', async (notification: ActionPerformed) => {
              if(notification){
                this.ngZone.run(() => {
                  this.router.navigateByUrl('/home/bottom-tabs/dashboard');
                });
              }
              console.log({notification});
            })

            // await PushNotifications.addListener('pushNotificationActionPerformed', notification => {
            //   console.log('Push notification action performed', notification.actionId, notification.inputValue);
            // });
          }
        }
        registerNotifications();
      }

    });
  }

  // setUpDeepLink() {
  //   this.platform.ready().then(async () => {
  //     this.deeplinks.route({
  //       '/shopeepay/order-status/:orderId': 'home/bottom-tabs/token/token-order-history',
  //       '/:orderId': 'home/bottom-tabs/token/token-order-history',
  //     }).subscribe(
  //       match => {
  //         console.log('Successfully matched route', match);
  //         // Create our internal Router path by hand
  //         const internalPath = `/${match.$route}/${match.$args['orderId']}`;
  //         console.log({internalPath});
  //         // Run the navigation in the Angular zone
  //         this.ngZone.run(() => {
  //           this.router.navigateByUrl(internalPath);
  //         });
  //       },
  //       nomatch => {
  //         // nomatch.$link - the full link data
  //         console.error("Got a deeplink that didn't match", nomatch);
  //       }
  //     );
  //   });
  // }

  async confirmExit() {
    const isAlertOpen = await this.alertController.getTop();
    if(!isAlertOpen){
      const alert = await this.alertController.create({
        message: 'Do you want to exit the application?',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            cssClass: 'secondary',
            id: 'cancel-button',
            handler: (blah) => {
              console.log('Confirm Cancel: blah');
            }
          }, {
            text: 'Yes',
            id: 'confirm-button',
            handler: () => {
              App.exitApp();
            }
          }
        ]
      });

      await alert.present();
    }
  }

  async logout() {
    this.store.dispatch(fromAuthActions.autoLogout());
  }

  async openIntro() {
    this.menu.enable(false);
    this.offlineStorageService.setObject(INTRO_KEY, false);
    this.navCtrl.navigateRoot('intro');
  }

  async sessionTimeOut() {
    const alert = await this.alertController.create({
      message: "Session Timeout!",
      backdropDismiss: false,
      buttons: [
        {
          text: "OK",
          handler: async () => {

          },
        },
      ],
    });
    await alert.present();
  }
}
